import { useEffect } from "react";

import { calculateGraphCoordsSystem } from "./utils";

import type { GGBApi, GraphOptions } from "./types";

export function useUpdateGeogebraApplet(
  api: GGBApi | null,
  options: Partial<GraphOptions> = {},
  onUpdate?: (api: GGBApi) => void,
) {
  useEffect(() => {
    if (api && options.width && options.height) {
      api.setSize(options.width, options.height);
      onUpdate?.(api);
    }
  }, [options.width, options.height, api, onUpdate]);

  useEffect(() => {
    if (api && options.width && options.height) {
      const coordsSystem = calculateGraphCoordsSystem({
        width: options.width,
        height: options.height,
        zoom: options.zoom,
        coordsSystem: options.coordsSystem,
      });

      if (coordsSystem) {
        api.setCoordSystem(...coordsSystem);
        onUpdate?.(api);
      }
    }
  }, [options.width, options.height, options.zoom, options.coordsSystem, api, onUpdate]);

  useEffect(() => {
    if (api && typeof options.gridType === "number") {
      api.setGraphicsOptions(1, { gridType: options.gridType });
      onUpdate?.(api);
    }
  }, [options.gridType, api, onUpdate]);

  useEffect(() => {
    if (!api) return;
    api.setAxisLabels(
      1,
      options.axisLabels ? (options.xAxisLabel ?? "") : "",
      options.axisLabels ? (options.yAxisLabel ?? "") : "",
      "",
    );
    onUpdate?.(api);
  }, [options.axisLabels, options.xAxisLabel, options.yAxisLabel, api, onUpdate]);

  useEffect(() => {
    if (!api) return;
    api?.setAxesVisible(1, !!options.axesVisible, !!options.axesVisible);
    onUpdate?.(api);
  }, [options.axesVisible, api, onUpdate]);
}
